import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { ApolloProvider } from '@apollo/client';
import '@cloudscape-design/global-styles/index.css';
import 'src/styles/global.scss';
import App from './App';
import { getApolloClient } from './api/client';
import { DarkModeProvider } from './common/ui/DarkModeContext';

// Injected by webpack DefinePlugin (see configuration/webpack.base.config.js).
// When true the app runs entirely against mocked GraphQL data with no backend
// connectivity (see the `server-mock` / `server-mock-noauth` scripts).
declare const MOCK_GRAPHQL: boolean;

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
const root = createRoot(container);

// Rendering is async because building the mock link may await asynchronously
// generated mock data (matching the FelineUIWebsite pattern).
const renderApp = async () => {
  const app = (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );

  let withGraphQL;
  if (MOCK_GRAPHQL) {
    const { MockedProvider } = await import('@apollo/client/testing');
    const { GQLWildcardLink } = await import('./api/mocks/mocks');
    withGraphQL = (
      <MockedProvider link={await GQLWildcardLink()} addTypename={false}>
        {app}
      </MockedProvider>
    );
  } else {
    withGraphQL = (
      <ApolloProvider client={getApolloClient()}>{app}</ApolloProvider>
    );
  }

  root.render(
    <React.StrictMode>
      <DarkModeProvider>{withGraphQL}</DarkModeProvider>
    </React.StrictMode>,
  );
};

void renderApp();
